<template>
    <div class="row">
        <div class="col-lg-8 col-xl-6">
            <div class="row">
                 <div class="col mx-2">
                     <form class="form-inline py-2 justify-content-start" >
                        <div class="d-flex align-items-center">
                            <button type="button" class="btn btn-back btn-lg" @click="$router.go(-1)">
                                <i class="fa fa-angle-left px-1"></i>
                            </button>
                            <h2 class="ml-2">Настройки аккаунта</h2>
                        </div>
                    </form>
                 </div>
            </div>
            <div class="form-group row mt-4">
                <label for="email" class="col-4 form-control-label">Эл. почта</label>
                <div class="col-8">
                    <input type="text" class="form-control" id="email" disabled v-model="email">
                </div>
            </div>
            <div class="form-group row mt-4">
                <label for="firstName" class="col-4 form-control-label">Имя</label>
                <div class="col-8">
                    <input type="text" class="form-control" id="firstName" v-model="firstName">
                </div>
            </div>
            <div class="form-group row">
                <label for="lastName" class="col-4 form-control-label">Фамилия</label>
                <div class="col-8">
                    <input type="text" class="form-control" id="address" v-model="lastName">
                </div>
            </div>
            <div class="row">
                <div class="ml-auto col-8">
                    <button type="button" class="btn btn-primary px-5" @click="updatePersonalInformation">{{ $t('settings.save') }}</button>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
import api from '../../api'
import { mapActions } from 'vuex'
export default {
  name: 'PersonalInformation',
  data: () => {
    return {
      firstName: '',
      lastName: '',
      email: ''
    }
  },
  created () {
    this.getProfile()
  },
  methods: {
    getProfile () {
      api.get.getProfile().then(resp => {
        const profile = resp.data.data.user
        this.email = profile.email
        this.firstName = profile.firstname
        this.lastName = profile.lastname
      })
    },
    updatePersonalInformation () {
      const profile = {
        firstname: this.firstName,
        lastname: this.lastName
      }
      api.post.updateProfile(profile).then(() => {
        this.getProfile()
        this.getUserInfo()
        this.$notify({
          message: this.$t('settings.company_info_updated'),
          type: 'success'
        })
      })
    },
    ...mapActions({
      getUserInfo: 'GET_USER_INFO'
    })
  }
}
</script>

<style>

</style>
